import { Flex } from "@chakra-ui/react";


export function Content({ sx = {}, children, ...props }: any) {

  return (
    <Flex w='100%' sx={{ p: { base: '20px', xl: '40px' }, ...sx }} position="relative" {...props}>
      {children}
    </Flex>
  )
}